import React from 'react';
import NodebookComments from './NodebookComments'
import Toggler from './Toggler'
import Styler from './Styler'
import URLList from './URLList'
import FilesList from './FilesList'
import * as d3 from "./d3.modified.js"
import { withRouter, Link } from 'react-router-dom'
import ColorPicker from './ColorPicker'
import Multipart from './Multipart'
import {PreviewNodebook} from './PreviewNodebook'
import NodebookSettings from './NodebookSettings'
import constants from '../ndbk-constants'
import PermissionsManager from './PermissionsManager'
import Utils from './Utils'
import {TemplatesLib} from './TemplatesLib'

export default class NodebookDetails extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            currentData: {},
            queuedDiffIds: [],
            infoTab: true,
            versioningTab: !(this.props.auth.user.isGuest===true),
            discussionTab: true,
            settingsTab: true,
            connectionsTab: false,
            appearanceTab: false,
            selectedTab: 'info'
        }

        this.mf = []
    }
    selectionChangeHandler = (change, cb=null) => {

        // console.log("SCC")

        let selection = this.props.getSelection()
        let nextTabs = {}
        let nextSelectedTab = {}
        if (selection.nodes.length===0 && selection.links.length===0) {
            nextTabs = {
                infoTab: true,
                versioningTab: !(this.props.auth.user.isGuest===true),
                discussionTab: true,
                settingsTab: true,
                connectionsTab: false,
                appearanceTab: false,
            }
            nextSelectedTab = 'info'
            // nextSelectedTab = nextTabs[this.state.selectedTab+'Tab']
            //     ? this.state.selectedTab
            //     :'info'
        } else if (selection.nodes.length!==0 && selection.links.length===0) {
            let allowConnsTab = false
            if (selection.nodes.length===1) {
                let node = this.props.nodesData[this.props.nodesHashTable[selection.nodes[0]]]
                if (node.linksList.length!==0) {
                    allowConnsTab = true
                }
            }
            nextTabs = {
                infoTab: true,
                versioningTab: false,
                discussionTab: (selection.nodes.length===1),
                settingsTab: false,
                connectionsTab: allowConnsTab,
                appearanceTab: true,
            }
            nextSelectedTab = 'info'
            // nextSelectedTab = nextTabs[this.state.selectedTab+'Tab']
            //     ? this.state.selectedTab
            //     :'info'
        } else if (selection.nodes.length===0 && selection.links.length!==0) {
            nextTabs = {
                infoTab: false,
                versioningTab: false,
                discussionTab: (selection.links.length===1),
                settingsTab: false,
                connectionsTab: false,
                appearanceTab: true,
            }
            nextSelectedTab = 'appearance'
            // nextSelectedTab = nextTabs[this.state.selectedTab+'Tab']
            //     ? this.state.selectedTab
            //         : (selection.links.length===1)
            //             ?'discussion'
            //             :'appearance'
        } else {
            nextTabs = {
                infoTab: true,
                versioningTab: false,
                discussionTab: false,
                settingsTab: false,
                connectionsTab: false,
                appearanceTab: false,
            }
            nextSelectedTab = 'info'
            // nextSelectedTab = nextTabs[this.state.selectedTab+'Tab']
            //     ? this.state.selectedTab
            //     :'info'
        }

        this.matchFields()

        this.setState({
            ...this.state,
            ...nextTabs,
            selectedTab: nextSelectedTab
        }, ()=>{
            if (cb) {
                cb()
            }
            // d3.selectAll('.nodebook-details')
            //     .on('keyup', ()=>{
            //         d3.event.stopPropagation()
            //     })
            //     .on('copy', () => {
            //         d3.event.stopPropagation()
            //     })
            //     .on('paste', () => {
            //         d3.event.stopPropagation()
            //     })
            //     .on('cut', () => {
            //         d3.event.stopPropagation()
            //     })
        })
    }

    componentDidUpdate() {
        if (this.onlyDataUpdate===true) {
            this.onlyDataUpdate = false
            return
        }

        d3.select(document.body).selectAll('textarea.details-input').each(
            function() {
                d3.select(this).style('height', '10px')
                d3.select(this).style('height', (this.scrollHeight+10>150?150:this.scrollHeight+10)+'px')
            }
        )
    }

    saveAllChanges = () => {
        this.props.nodesData.forEach(
            nodeItem => this.saveChanges(nodeItem, 'node')
        )
        this.props.linksData.forEach(
            linkItem => this.saveChanges(linkItem, 'link')
        )
    }

    saveChanges = (item, _itemType) => {

        // links
        if ('link'===_itemType) {
            var from_node = this.props.nodesData[this.props.nodesHashTable[item.from_id]]
            var to_node = this.props.nodesData[this.props.nodesHashTable[item.to_id]]
            if (from_node._compareType!=='none' || to_node._compareType!=='none') {
                // i.e. only apply link changes if both nodes are already applied to the
                this.props.selectNode()
                return
            }

            if ('green'===item._compareType) {
                let props = {
                    properties: {},
                    linkHash: item.link_hash,
                }
                TemplatesLib[4].fields.forEach(field=>props.properties[field.name]=item.properties[field.name])
                // assure to get the newest IDs
                item.from_id = from_node.id
                item.to_id = to_node.id

                let {from_id, to_id, link_hash, ...rest} = item
                let propsData = rest.properties || {}

                let linksData = [{
                    targetNodeId:to_id, sourceNodeId:from_id, linkHash:link_hash, propsData
                }]

                this.props.createLinks(linksData, true, ()=> {
                    item._compareType = 'none'
                    item._jsx.dom.forceUpdate();
                })

                //this.props.createLink(to_node, [item.from_id], true, props, ()=>{
                //    item._compareType = 'none'
                //})
            } else if ('yellow'===item._compareType) {
                let props = {
                    properties: {}
                }
                Object.keys(item._diff).forEach(
                    fieldName => {
                        props.properties[fieldName] = item._diff[fieldName].clone
                    }
                )
                item._compareType = 'none'
                this.props.selectionUpdateAll(props.properties, {nodes: [], links: [item.id]}, ()=>{this.props.selectLink(item)}, true, true)
            } else if ('red'===item._compareType) {
                this.props.selectionDeleteAll({nodes: [], links: [item.id]}, true)
            }
        } else {
            // nodes
            if ('green'===item._compareType) {
                let props = Object.assign({}, item.properties)
                props.width = item.width
                props.height = item.height
                props.x = item.x
                props.y = item.y
                //props._nodeHash = item.node_hash
                item._compareType = 'none'
                let data = [{
                    properties: props,
                    nodeHash: item.node_hash,
                }]
                // console.log(item, data)
                // console.log(JSON.stringify(item))
                this.props.createNodes(data, (newNodes)=>{
                    var newNode = newNodes[0]
                    var oldId = item.id
                    item.id=newNode.id
                    // JSON.stringify(newNode)
                    this.props.nodesHashTable[item.id] = this.props.nodesHashTable[oldId]
                }, true)
            } else if ('yellow'===item._compareType) {
                let props = {}
                Object.keys(item._diff).forEach(
                    fieldName => {
                        if (item._diff[fieldName].both) {
                            // array type
                            props[fieldName] = [...item._diff[fieldName].both, ...item._diff[fieldName].clone]
                        } else {
                            props[fieldName] = item._diff[fieldName].clone
                        }
                    }
                )
                this.props.selectionUpdateAll(props, {nodes: [item.id], links: []}, ()=>{item._compareType = 'none'; this.props.selectNode(item)}, true, true)
            } else if ('red'===item._compareType) {
                this.props.selectionDeleteAll({nodes: [item.id], links: []}, true)
            }
        }
    }

    matchFields = () => {
        this.mf = []
        var selection = this.props.getSelection()

        if (selection.nodes.length === 0 && selection.links.length === 0) {
            return
        }

        // TODO optim for just new additions to select/deselect

        this.state.currentData = {}
        var _matching = {}

        if (selection.nodes.length!=0) {
            selection.nodes.forEach(
                nodeId => {
                    var node = this.props.nodesData[this.props.nodesHashTable[nodeId]]
                    var fields = this.props.templatesData[node.properties.templateId].fields
                    fields.forEach(
                        field => {
                            var _hash = `${field.name}-${field.type}`
                            if (undefined === _matching[_hash]) {
                                _matching[_hash] = {
                                    val: node.properties[field.name],
                                    num: 1,
                                    label: field.label,
                                    hasRender: field.hasRender
                                }
                            } else {
                                if ('array' === field.type /*&& _matching[_hash].val*/) {
                                    var _same = []
                                    _matching[_hash].val.forEach(
                                        item => {
                                            if (node.properties[field.name].indexOf(item)!=-1) {
                                                _same.push(item)
                                            }
                                        }
                                    )
                                    _matching[_hash].val = _same
                                    _matching[_hash].num++
                                } else if ('ref' === field.type) {
                                    _matching[_hash].val = undefined
                                    _matching[_hash].num++
                                } else if ('img' === field.type) {
                                    _matching[_hash].val = undefined
                                    _matching[_hash].num++
                                }else if ('_render' === field.type) {
                                    let val = _matching[_hash].val
                                    let newVal = {}

                                    Object.keys(val).forEach(fn=>{
                                        newVal[fn] = {}
                                        // console.log("field name", fn)
                                        Object.keys(val[fn]).forEach(pn=>{
                                            // console.log("prop", pn, val[fn][pn], node.properties._render[fn][pn])
                                            if (node.properties._render[fn] && val[fn][pn]===node.properties._render[fn][pn]) {
                                                // console.log("same")
                                                newVal[fn][pn]=val[fn][pn]
                                            }
                                        })
                                    })

                                    _matching[_hash].val = newVal
                                    _matching[_hash].num++
                                } else if ('likes' === field.type) {
                                    _matching[_hash].val = undefined
                                    _matching[_hash].num++
                                } else if ('files' === field.type) {
                                    _matching[_hash].val = undefined
                                    _matching[_hash].num++
                                } else if ('layout' === field.type && node.properties[field.name]!==_matching[_hash].val) {
                                    _matching[_hash].val = undefined
                                    _matching[_hash].num++
                                } else if ('url' === field.type) {
                                    _matching[_hash].val = undefined
                                    _matching[_hash].num++
                                } else if ('file' === field.type) {
                                    _matching[_hash].val = '(...)'
                                    _matching[_hash].num++
                                /*} else if ('idsgroup' === field.type) {
                                    _matching[_hash].val = '(...)'
                                    _matching[_hash].num++ */
                                } else {
                                    if (_matching[_hash].val != node.properties[field.name]) {
                                        _matching[_hash].val = '(...)'
                                    }
                                    _matching[_hash].num++
                                }

                                _matching[_hash].hasRender = _matching[_hash].hasRender && field.hasRender
                            }

                            if (_matching[_hash].num === selection.nodes.length) {
                                this.state.currentData[field.name] = {
                                    val: _matching[_hash].val,
                                    type: field.type,
                                    label: _matching[_hash].label,
                                    name: field.name,
                                    hasRender: _matching[_hash].hasRender
                                }
                                this.mf.push(field.name)
                            }
                        }
                    )
                }
            )
        } else {
            selection.links.forEach(
                linkId => {
                    var link = this.props.linksData[this.props.linksHashTable[linkId]]
                    this.props.templatesData[4].fields.forEach(
                        field => {
                            var prop = field.name
                            if (undefined === _matching[prop]) {
                                this.mf.push(prop)
                                _matching[prop] = {
                                    val: link.properties[prop],
                                    type: field.type,
                                    label: field.label,
                                    settings: {}
                                }
                            } else {
                                if (_matching[prop].val != link.properties[prop]) {
                                    _matching[prop].val = ''
                                }
                            }
                        }
                    )
                }
            )
            this.mf.forEach(prop => this.state.currentData[prop] = _matching[prop])
        }

        // console.log(this.state.currentData._render)
    }

    updateSelection = (cb=null, extra={}) => {
        this.onlyDataUpdate = true
        var newProperties = extra
        this.mf.forEach(
            fieldName => {
                // update property if it was changed
                if (this.state.currentData[fieldName].wasChanged) {
                    newProperties[fieldName] = this.state.currentData[fieldName].val
                    this.state.currentData[fieldName].wasChanged = false
                }
            }
        )
        this.props.selectionUpdateAllLocalFirst(newProperties, this.props.getSelection(), ()=>{
            if (cb) {
                cb()
            }
        })
    }

    renderOneField = (fieldName, isStyleTab=false) => {
        var field = this.state.currentData[fieldName]
        var _disabled = !(this.props.nodebookInfo.permissions && this.props.authLevel[this.props.nodebookInfo.permissions]>1)

        switch (field.type) {
            case 'ref':
                if (isStyleTab) {
                    return null
                }
                // has at least something
                if (field.val && field.val!=='') {
                    // has both nodebook ID and node ID
                    if (field.val.node_id) {
                        return (
                            <p key='ref_p'><strong>{field.label}</strong> <br/>
                                <Link to={`/nodebook/${field.val.nodebook_id}/query/ids=${field.val.node_id}`}>/nodebook/{field.val.nodebook_id}/query/ids=/{field.val.node_id}</Link>
                            </p>
                        )
                    // has only nodebook ID
                    } else {
                        return (
                            <div key='ref_p' style={{backgroundColor: "#f8f8f8", padding: "10px"}}>{/*<strong>{field.label}</strong> <br/>*/}
                                <Link to={`/nodebook/${field.val.nodebook_id}`}>
                                    <PreviewNodebook nowrap nodatasohereisid={field.val.nodebook_id} />
                                </Link>
                            </div>
                        )
                    }
                }
                return null
                break
            // case 'nodetype':
            //     return null
                // if (!isStyleTab) {
                //     return null
                // }

                // return (
                //     <button onClick={()=>{}}>Document</button>
                //     <button onClick={()=>{}}>Category</button>
                //     <button onClick={()=>{}}>Label</button>
                //     <button onClick={()=>{}}>Marker</button>
                //     <button onClick={()=>{}}>Icon</button>
                // )
                // break
            case 'linktype':
                return null
                break
            case 'linkweight':
                return null
                break
            case 'linkwidth':
                if (!isStyleTab) {
                    return null
                }

                return (
                    <p key={fieldName+'_p'}>
                        <strong>Width</strong><br/>
                        <span
                            className="curve"
                            title="1px"
                            onClick={()=>{
                                this.state.currentData.width.val = 1
                                this.state.currentData.width.wasChanged = true
                                this.updateSelection()
                            }}
                        >
                            <svg width="20" height="20">
                                <path d="M 0 0 L 20 20" />
                            </svg>
                        </span>
                        <span
                            className="curve"
                            title="2px"
                            onClick={()=>{
                                this.state.currentData.width.val = 2
                                this.state.currentData.width.wasChanged = true
                                this.updateSelection()
                            }}
                        >
                            <svg width="20" height="20">
                                <path d="M 0 0 L 20 20" style={{strokeWidth: 2}}/>
                            </svg>
                        </span>
                        <span
                            className="curve"
                            title="4px"
                            onClick={()=>{
                                this.state.currentData.width.val = 4
                                this.state.currentData.width.wasChanged = true
                                this.updateSelection()
                            }}
                        >
                            <svg width="20" height="20">
                                <path d="M 0 0 L 20 20" style={{strokeWidth: 4}}/>
                            </svg>
                        </span>
                        <span
                            className="curve"
                            title="8px"
                            onClick={()=>{
                                this.state.currentData.width.val = 8
                                this.state.currentData.width.wasChanged = true
                                this.updateSelection()
                            }}
                        >
                            <svg width="20" height="20">
                                <path d="M 0 0 L 20 20" style={{strokeWidth: 8}}/>
                            </svg>
                        </span>
                    </p>
                )
                break
            case 'linkshape':
                if (!isStyleTab) {
                    return null
                }

                return <p key={fieldName+'_p'}>
                    <strong>Shape</strong><br/>
                    <span
                        className="curve"
                        title="Curved, horizontal flow"
                        onClick={()=>{
                            this.state.currentData.w1x.val = 0.75
                            this.state.currentData.w1x.wasChanged = true
                            this.state.currentData.w1y.val = 0.0
                            this.state.currentData.w1y.wasChanged = true
                            this.state.currentData.w2x.val = 0.25
                            this.state.currentData.w2x.wasChanged = true
                            this.state.currentData.w2y.val = 1.0
                            this.state.currentData.w2y.wasChanged = true
                            this.updateSelection()
                        }}
                    >
                        <svg width="20" height="20">
                            <path d="M 0 0 C 15 0, 5 20, 20 20" />
                        </svg>
                    </span>
                    <span
                        className="curve"
                        title="Curved, vertical flow"
                        onClick={()=>{
                            this.state.currentData.w1x.val = 0.0
                            this.state.currentData.w1x.wasChanged = true
                            this.state.currentData.w1y.val = 0.75
                            this.state.currentData.w1y.wasChanged = true
                            this.state.currentData.w2x.val = 1.0
                            this.state.currentData.w2x.wasChanged = true
                            this.state.currentData.w2y.val = 0.25
                            this.state.currentData.w2y.wasChanged = true
                            this.updateSelection()
                        }}
                    >
                        <svg width="20" height="20">
                            <path d="M 0 0 C 0 15, 20 5, 20 20" />
                        </svg>
                    </span>
                    <span
                        className="curve"
                        title="Straight"
                        onClick={()=>{
                            this.state.currentData.w1x.val = 0.333
                            this.state.currentData.w1x.wasChanged = true
                            this.state.currentData.w1y.val = 0.333
                            this.state.currentData.w1y.wasChanged = true
                            this.state.currentData.w2x.val = 0.667
                            this.state.currentData.w2x.wasChanged = true
                            this.state.currentData.w2y.val = 0.667
                            this.state.currentData.w2y.wasChanged = true
                            this.updateSelection()
                        }}
                    >
                        <svg width="20" height="20">
                            <path d="M 0 0 L 20 20" />
                        </svg>
                    </span>
                    <span
                        className="curve"
                        title="Curved, type A"
                        onClick={()=>{
                            this.state.currentData.w1x.val = 0.0
                            this.state.currentData.w1x.wasChanged = true
                            this.state.currentData.w1y.val = 1.0
                            this.state.currentData.w1y.wasChanged = true
                            this.state.currentData.w2x.val = 0.0
                            this.state.currentData.w2x.wasChanged = true
                            this.state.currentData.w2y.val = 1.0
                            this.state.currentData.w2y.wasChanged = true
                            this.updateSelection()
                        }}
                    >
                        <svg width="20" height="20">
                            <path d="M 0 0 C 0 15, 5 20, 20 20" />
                        </svg>
                    </span>
                    <span
                        className="curve"
                        title="Curved, type B"
                        onClick={()=>{
                            this.state.currentData.w1x.val = 1.0
                            this.state.currentData.w1x.wasChanged = true
                            this.state.currentData.w1y.val = 0.0
                            this.state.currentData.w1y.wasChanged = true
                            this.state.currentData.w2x.val = 1.0
                            this.state.currentData.w2x.wasChanged = true
                            this.state.currentData.w2y.val = 0.0
                            this.state.currentData.w2y.wasChanged = true
                            this.updateSelection()
                        }}
                    >
                        <svg width="20" height="20">
                            <path d="M 0 0 C 15 0, 20 5, 20 20" />
                        </svg>
                    </span>
                </p>
                break
             case 'linksymbol':
                if (!isStyleTab) {
                    return null
                }

                return <p key={fieldName+'_p'}>
                    <strong>Symbol</strong><br/>
                    <span
                        className="curve"
                        title="None"
                        onClick={()=>{
                            this.state.currentData.linksymbol.val = null
                            this.state.currentData.linksymbol.wasChanged = true
                            this.updateSelection()
                        }}
                    >
                    </span>
                    <span
                        className="curve"
                        title="Triangle"
                        onClick={()=>{
                            this.state.currentData.linksymbol.val = 'triangle'
                            this.state.currentData.linksymbol.wasChanged = true
                            this.updateSelection()
                        }}
                    >
                        <svg width="20" height="20" viewBox="0 -10 20 20">
                            <path d="M 3 -4 L 17 0 L 3 4 Z" style={{fill: '#888', stroke: 'none'}}/>
                        </svg>
                    </span>
                    <span
                        className="curve"
                        title="Triangle reversed"
                        onClick={()=>{
                            this.state.currentData.linksymbol.val = 'triangle_reversed'
                            this.state.currentData.linksymbol.wasChanged = true
                            this.updateSelection()
                        }}
                    >
                        <svg width="20" height="20" viewBox="0 -10 20 20">
                            <path d="M 17 4 L 3 0 L 17 -4 Z" style={{fill: '#888', stroke: 'none'}}/>
                        </svg>
                    </span>
                    <span
                        className="curve"
                        title="Diamond"
                        onClick={()=>{
                            this.state.currentData.linksymbol.val = 'diamond'
                            this.state.currentData.linksymbol.wasChanged = true
                            this.updateSelection()
                        }}
                    >
                        <svg width="20" height="20" viewBox="0 -10 20 20">
                            <path d="M 0 0 L 10 4 L 20 0 L 10 -4 Z" style={{fill: '#888', stroke: 'none'}}/>
                        </svg>
                    </span>
                </p>
                break
            case 'likes':
                if (field.val===undefined || isStyleTab) {
                    return null
                }

                return (
                    <p key="votes_p">
                        <svg width="20" height="20" className="upvote" title="Upvote" style={{marginRight: '10px'}}onClick={()=>{
                            field.val++
                            field.wasChanged = true
                            this.updateSelection()
                            this.props.nodesData[this.props.nodesHashTable[this.props.getSelection().nodes[0]]]._jsx.dom.forceUpdate()
                        }}>
                            <path fill="#888" d="M18.916 11.208c0.443-0.511 0.695-1.355 0.695-2.159 0-0.531-0.115-0.996-0.333-1.345-0.284-0.454-0.738-0.704-1.278-0.704h-2.618c1.425-2.591 1.785-4.543 1.070-5.807-0.499-0.881-1.413-1.193-2.045-1.193-0.25 0-0.462 0.185-0.495 0.433-0.179 1.319-1.188 2.893-2.768 4.318-1.514 1.365-3.374 2.456-5.286 3.11-0.241-0.508-0.758-0.86-1.356-0.86h-3c-0.827 0-1.5 0.673-1.5 1.5v9c0 0.827 0.673 1.5 1.5 1.5h3c0.634 0 1.176-0.395 1.396-0.952 1.961 0.246 2.699 0.64 3.414 1.022 0.895 0.478 1.739 0.93 4.503 0.93 0.72 0 1.398-0.188 1.91-0.529 0.5-0.333 0.82-0.801 0.926-1.343 0.399-0.162 0.753-0.536 1.024-1.092 0.264-0.541 0.435-1.232 0.435-1.761 0-0.099-0.006-0.19-0.017-0.274 0.253-0.186 0.48-0.473 0.667-0.851 0.27-0.545 0.432-1.228 0.432-1.826 0-0.424-0.079-0.777-0.234-1.051-0.013-0.022-0.026-0.044-0.039-0.065zM4.5 18h-3c-0.276 0-0.5-0.224-0.5-0.5v-9c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v8.999c0 0 0 0.001 0 0.001-0 0.276-0.224 0.5-0.5 0.5zM18.339 10.274c-0.151 0.304-0.304 0.414-0.37 0.414-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.042 0 0.072 0 0.117 0.078 0.066 0.117 0.104 0.32 0.104 0.558 0 0.445-0.126 0.974-0.328 1.382-0.198 0.399-0.399 0.544-0.487 0.544-0.276 0-0.5 0.224-0.5 0.5 0 0.177 0.092 0.333 0.231 0.422 0.031 0.317-0.117 1.165-0.501 1.718-0.145 0.209-0.298 0.329-0.418 0.329-0.276 0-0.5 0.224-0.5 0.5 0 0.88-0.972 1.281-1.875 1.281-2.513 0-3.217-0.376-4.032-0.812-0.762-0.407-1.618-0.865-3.781-1.134v-8.187c2.101-0.689 4.152-1.877 5.812-3.373 1.593-1.436 2.639-2.988 2.994-4.426 0.272 0.087 0.579 0.271 0.776 0.618 0.334 0.59 0.584 2.096-1.493 5.557-0.093 0.154-0.095 0.347-0.006 0.504s0.255 0.254 0.435 0.254h3.483c0.199 0 0.327 0.070 0.43 0.234 0.117 0.187 0.181 0.477 0.181 0.815 0 0.424-0.102 0.882-0.272 1.225z"></path>
                        </svg>
                        <svg width="20" height="20" className="downvote" title="Downvote" onClick={()=>{
                            field.val--
                            field.wasChanged = true
                            this.updateSelection()
                            this.props.nodesData[this.props.nodesHashTable[this.props.getSelection().nodes[0]]]._jsx.dom.forceUpdate()
                        }}>
                            <path fill="#888" d="M18.916 8.792c0.443 0.511 0.695 1.355 0.695 2.159 0 0.531-0.115 0.996-0.333 1.345-0.284 0.454-0.738 0.704-1.278 0.704h-2.618c1.425 2.591 1.785 4.543 1.070 5.807-0.499 0.881-1.413 1.193-2.045 1.193-0.25 0-0.462-0.185-0.495-0.433-0.179-1.319-1.188-2.893-2.768-4.318-1.514-1.365-3.374-2.456-5.286-3.11-0.241 0.508-0.758 0.86-1.356 0.86h-3c-0.827 0-1.5-0.673-1.5-1.5v-9c0-0.827 0.673-1.5 1.5-1.5h3c0.634 0 1.176 0.395 1.396 0.952 1.961-0.246 2.699-0.64 3.414-1.022 0.895-0.478 1.739-0.93 4.503-0.93 0.72 0 1.398 0.188 1.91 0.529 0.5 0.333 0.82 0.801 0.926 1.343 0.399 0.162 0.753 0.536 1.024 1.092 0.264 0.541 0.435 1.232 0.435 1.761 0 0.099-0.006 0.19-0.017 0.274 0.253 0.186 0.48 0.473 0.667 0.851 0.27 0.545 0.432 1.228 0.432 1.826 0 0.424-0.079 0.777-0.234 1.051-0.013 0.022-0.026 0.044-0.039 0.065zM4.5 2h-3c-0.276 0-0.5 0.224-0.5 0.5v9c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-8.999c0-0 0-0.001 0-0.001-0-0.276-0.224-0.5-0.5-0.5zM18.339 9.726c-0.151-0.304-0.304-0.414-0.37-0.414-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c0.042 0 0.072 0 0.117-0.078 0.066-0.117 0.104-0.32 0.104-0.558 0-0.445-0.126-0.974-0.328-1.382-0.198-0.399-0.399-0.544-0.487-0.544-0.276 0-0.5-0.224-0.5-0.5 0-0.177 0.092-0.333 0.231-0.422 0.031-0.317-0.117-1.165-0.501-1.718-0.145-0.209-0.298-0.329-0.418-0.329-0.276 0-0.5-0.224-0.5-0.5 0-0.88-0.972-1.281-1.875-1.281-2.513 0-3.217 0.376-4.032 0.812-0.762 0.407-1.618 0.865-3.781 1.134v8.187c2.101 0.689 4.152 1.877 5.812 3.373 1.593 1.436 2.639 2.988 2.994 4.426 0.272-0.087 0.579-0.271 0.776-0.618 0.334-0.59 0.584-2.096-1.493-5.557-0.093-0.154-0.095-0.347-0.006-0.504s0.255-0.254 0.435-0.254h3.483c0.199 0 0.327-0.070 0.43-0.234 0.117-0.187 0.181-0.477 0.181-0.815 0-0.424-0.102-0.882-0.272-1.225z"></path>
                        </svg>
                    </p>
                )
                break
            case '_render':
                return null
                break
            case 'color':
                if (!isStyleTab) {
                    return null
                }

                return <p key={fieldName+'_p'}>
                    <strong>{field.label}</strong>
                    <ColorPicker
                        disabled={_disabled}
                        defaultValue={field.val}
                        // color = {field.val}
                        colors = {['#e5f3ff', '#fff', '#d8ffc9', '#fdffc9', '#fdd8fb', '#ff9b9b', '#d3fdfd', '#fbd6af']}
                        onChange={color=>{
                            field.val = color
                            field.wasChanged = true
                            this.updateSelection()
                        }}
                    />
                </p>
                break
            case 'img':
                if (!isStyleTab || _disabled || field.val===undefined) {
                    return null
                }

                return (
                    <p key={fieldName+'_p'}>
                        <label className="imgup">
                            <svg width="16" height="16" viewBox="0 0 20 20">
                                <path fill="#888" d="M18.5 20h-17c-0.827 0-1.5-0.673-1.5-1.5v-17c0-0.827 0.673-1.5 1.5-1.5h17c0.827 0 1.5 0.673 1.5 1.5v17c0 0.827-0.673 1.5-1.5 1.5zM1.5 1c-0.276 0-0.5 0.224-0.5 0.5v17c0 0.276 0.224 0.5 0.5 0.5h17c0.276 0 0.5-0.224 0.5-0.5v-17c0-0.276-0.224-0.5-0.5-0.5h-17z"></path>
                                <path fill="#888" d="M13 9c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM13 6c-0.551 0-1 0.449-1 1s0.449 1 1 1 1-0.449 1-1-0.449-1-1-1z"></path>
                                <path fill="#888" d="M17.5 2h-15c-0.276 0-0.5 0.224-0.5 0.5v12c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-12c0-0.276-0.224-0.5-0.5-0.5zM3 11.69l3.209-3.611c0.082-0.092 0.189-0.144 0.302-0.145s0.221 0.048 0.305 0.138l5.533 5.928h-9.349v-2.31zM17 14h-3.283l-6.169-6.61c-0.279-0.299-0.651-0.461-1.049-0.456s-0.766 0.176-1.037 0.481l-2.462 2.77v-7.185h14v11z"></path>
                            </svg>
                            Choose thumbnail
                            <input type="file" multiple={false} style={{display: 'none'}} onChange={e=>{
                                let file = e.target.files[0]
                                this.props.onNodeFileInput(file, this.props.getSelection().nodes[0], (data)=>{
                                    field.val = data.file
                                    field.wasChanged = true
                                    this.updateSelection()
                                })
                            }}/>
                        </label>
                        {
                            (field.val!=='')
                                ? (
                                    <span className="rmimg" onClick={()=>{
                                        field.val = ''
                                        field.wasChanged = true
                                        this.updateSelection()
                                    }}>(remove)</span>
                                ) : null
                        }
                    </p>
                )
            case 'layout':
                if (!isStyleTab || _disabled) {
                    return null
                }

                return <p key={fieldName+'_p'}>
                    <strong>{field.label}</strong><br/>
                    <span className={`layouttype${field.val===12?' selected':''}`} onClick={(e)=>{
                        this.props.getSelection().nodes.forEach(nodeId=>{
                            let node = this.props.nodesData[this.props.nodesHashTable[nodeId]]
                            node.properties.templateId = 12
                            node.properties = this.props.setDefaultProps(node.properties)
                        })
                        this.updateSelection(()=>{
                            this.matchFields()
                            this.forceUpdate()
                        }, {
                            templateId: 12,
                            layout: 12,
                        })
                    }}>Node</span>
                    <span className={`layouttype${field.val===9?' selected':''}`} onClick={(e)=>{
                        this.props.getSelection().nodes.forEach(nodeId=>{
                            let node = this.props.nodesData[this.props.nodesHashTable[nodeId]]
                            node.properties.templateId = 9
                            node.properties = this.props.setDefaultProps(node.properties)
                        })
                        this.updateSelection(()=>{
                            this.matchFields()
                            this.forceUpdate()
                        }, {
                            templateId: 9,
                            layout: 9,
                        })
                    }}>Category</span>
                    {/*<span className={`layouttype${field.val===11?' selected':''}`} onClick={(e)=>{
                        this.props.getSelection().nodes.forEach(nodeId=>{
                            let node = this.props.nodesData[this.props.nodesHashTable[nodeId]]
                            node.properties.templateId = 11
                            node.properties = this.props.setDefaultProps(node.properties)
                        })
                        this.updateSelection(()=>{
                            this.matchFields()
                            this.forceUpdate()
                        }, {
                            templateId: 11,
                            layout: 11,
                        })
                    }}>Note</span>*/}
                    <span className={`layouttype${field.val===10?' selected':''}`} onClick={(e)=>{
                        this.props.getSelection().nodes.forEach(nodeId=>{
                            let node = this.props.nodesData[this.props.nodesHashTable[nodeId]]
                            node.properties.templateId = 10
                            node.properties = this.props.setDefaultProps(node.properties)
                        })
                        this.updateSelection(()=>{
                            this.matchFields()
                            this.forceUpdate()
                        }, {
                            templateId: 10,
                            layout: 10,
                        })
                    }}>Academic node</span>

                </p>
                break
            case 'idsgroup':
                if (isStyleTab) {
                    return null
                }

                return [<hr key="ubimeboze"/>,
                <p key={fieldName+'_p'}>
                    {
                        ['arxivId', 'doi', 'isbn', 'issn', 'pmid'].map(idField =>  {
                            var subfield = this.state.currentData[idField]
                            return <span key={idField+"_subf"} className="idinp">
                                        <strong>{subfield.label}</strong>
                                        <input
                                            // disabled={_disabled}
                                            readOnly={_disabled}
                                            type="text"
                                            placeholder={subfield.val==='(...)'?'(...)':''}
                                            value={subfield.val==='(...)'?(subfield.val=''):subfield.val}
                                            className="details-input idinp"
                                            spellCheck="false"
                                            onChange={(e)=>{
                                                subfield.val = e.target.value;
                                                subfield.wasChanged = true;
                                                this.updateSelection()
                                            }}
                                        />
                                    </span>
                        })
                    }
                </p>
                ]
                break
            case 'oneid':
                return null
                break
            case 'files':
                if (field.val===undefined || isStyleTab) {
                    return null
                }

                if (_disabled && field.val.length===0) {
                    return null
                }

                let nodeId = this.props.getSelection().nodes[0]
                let nd = this.props.nodesData[this.props.nodesHashTable[nodeId]]

                return (
                    <FilesList
                        key={fieldName+'_files'}
                        disabled={_disabled}
                        defaultValue={field.val}
                        node={nd}
                        selectionUpdateAllLocalFirst={this.props.selectionUpdateAllLocalFirst}
                        updateNodesLocally={this.props.updateNodesLocally}
                        updateNodesRemotely={this.props.updateNodesRemotely}
                        onChange={()=>{
                            this.matchFields()
                            this.forceUpdate()
                        }}
                    />
                )
                break
            case 'file':
                if (isStyleTab) {
                    return null
                }

                if (field.val==='(...)') {
                    return null
                }

                let noFile = (!field.val || field.val==='')

                let _addChangeFileBtn = (
                    <span className="file" key={noFile?"addFile":'changdeFile'}>
                        <label className="file">

                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                    <path fill="#666" d="M17.854 5.646l-4.5-4.5c-0.094-0.094-0.221-0.146-0.354-0.146h-9.5c-0.827 0-1.5 0.673-1.5 1.5v16c0 0.827 0.673 1.5 1.5 1.5h13c0.827 0 1.5-0.673 1.5-1.5v-12.5c0-0.133-0.053-0.26-0.146-0.354zM16.793 6h-3.293c-0.276 0-0.5-0.224-0.5-0.5v-3.293l3.793 3.793zM16.5 19h-13c-0.276 0-0.5-0.224-0.5-0.5v-16c0-0.276 0.224-0.5 0.5-0.5h8.5v3.5c0 0.827 0.673 1.5 1.5 1.5h3.5v11.5c0 0.276-0.224 0.5-0.5 0.5z"></path>
                                    {
                                    (noFile)
                                        ? <path fill="#666" d="M11.5 13h-2.5v-2.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v2.5h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5v2.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.5h2.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z"></path>
                                        : null
                                    }
                                </svg>
                             {noFile?'Add file':'Change file'}
                             <input
                                style={{width: 0,display: 'none', padding: 0 ,margin: 0}}
                                type="file"
                                multiple={false}
                                onChange={(e) => {
                                    this.props.onNodeFileInput(e.target.files, this.props.getSelection().nodes[0], (props)=>{
                                        field.val = props.file
                                        field.wasChanged = true
                                        this.updateSelection()
                                    })
                                }}
                            />

                        </label>
                    </span>
                )

                let _openFileBtn = (
                    <span className="file" key="openFile">
                        <a target="_blank" href={field.val} title={"Open file"}>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                <path fill="#666" d="M17.5 19h-16c-0.827 0-1.5-0.673-1.5-1.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276 0.224 0.5 0.5 0.5h16c0.276 0 0.5-0.224 0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.827-0.673 1.5-1.5 1.5z"></path>
                                <path fill="#666" d="M14.854 8.646l-5-5c-0.195-0.195-0.512-0.195-0.707 0l-5 5c-0.195 0.195-0.195 0.512 0 0.707s0.512 0.195 0.707 0l4.146-4.146v10.293c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10.293l4.146 4.146c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707z"></path>
                            </svg> Open file
                        </a>
                    </span>
                )

                let _removeFileBtn = (
                    <span className="file" key="removeFile" onClick={()=>{
                        field.val = ''
                        field.wasChanged = true
                        this.updateSelection()
                    }}>
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                            <path fill="#666" d="M15.5 2h-3.5v-0.5c0-0.827-0.673-1.5-1.5-1.5h-2c-0.827 0-1.5 0.673-1.5 1.5v0.5h-3.5c-0.827 0-1.5 0.673-1.5 1.5v1c0 0.652 0.418 1.208 1 1.414v12.586c0 0.827 0.673 1.5 1.5 1.5h10c0.827 0 1.5-0.673 1.5-1.5v-12.586c0.582-0.206 1-0.762 1-1.414v-1c0-0.827-0.673-1.5-1.5-1.5zM8 1.5c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v0.5h-3v-0.5zM14.5 19h-10c-0.276 0-0.5-0.224-0.5-0.5v-12.5h11v12.5c0 0.276-0.224 0.5-0.5 0.5zM16 4.5c0 0.276-0.224 0.5-0.5 0.5h-12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5h12c0.276 0 0.5 0.224 0.5 0.5v1z"></path>
                            <path fill="#666" d="M12.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z"></path>
                            <path fill="#666" d="M9.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z"></path>
                            <path fill="#666" d="M6.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z"></path>
                        </svg> Remove file
                    </span>
                )

                if (_disabled) {
                    _addChangeFileBtn = null
                    // _openFileBtn = null
                    _removeFileBtn = null
                }

                return (
                    <p key={fieldName+'_p'} style={{textAlign: 'center'}}>
                        {
                            (noFile)
                                ? [_addChangeFileBtn]
                                : [_openFileBtn, _addChangeFileBtn, _removeFileBtn]
                        }
                    </p>
                )
                break
            case 'url':
                if (isStyleTab || field.val===undefined) {
                    return null
                }

                return (
                    <URLList
                        key={fieldName+'_url'}
                        disabled={_disabled}
                        defaultValue={field.val}
                        onChange={val=>{
                            field.val = val
                            field.wasChanged = true
                            this.updateSelection()
                        }}
                    />
                )
                break
            default:
                if (isStyleTab) {
                    return null
                }

                var contentSettings = null
                var contentField = null
                // settings
                if (field.hasRender && !_disabled) {
                    contentSettings = (
                        <Styler
                            // hideViewToggle={field.name==='title'}
                            val={this.state.currentData['_render'].val[field.name]}
                            fn={field.name}
                            onChange={(name, val)=>{
                                let newNodeRenderProps = []
                                this.props.getSelection().nodes.forEach(nodeId=>{
                                    let node = this.props.nodesData[this.props.nodesHashTable[nodeId]]
                                    let newProps = {}
                                    Object.keys(node.properties._render).forEach(fn=>{
                                        newProps[fn] = {...node.properties._render[fn]}
                                    })
                                    newProps[field.name][name] = val
                                    newNodeRenderProps.push({
                                        _render: newProps
                                    })
                                })
                                // console.log(newNodeRenderProps)
                                this.state.currentData['_render'].val[field.name] = {...this.state.currentData['_render'].val[field.name], [name]: val}
                                this.props.selectionUpdateAllLocalFirst(newNodeRenderProps, {nodes:this.props.getSelection().nodes, links: []}, ()=>{
                                    this.matchFields()
                                    this.forceUpdate()
                                })
                            }}
                        />
                    )
                }
                // field content
                contentField = ('textarea'===field.type)
                    ?   <textarea
                            // disabled={_disabled}
                            readOnly={_disabled}
                            key={fieldName+'_input'}
                            className="details-input"
                            spellCheck="false"
                            placeholder={field.val==='(...)'?'(...)':''}
                            value={field.val==='(...)'?(field.val=''):field.val}
                            onChange={(e)=>{
                                field.val = e.target.value;
                                field.wasChanged = true;
                                this.updateSelection()
                            }}
                        />
                    : ('array'===field.type)
                        ?   <Multipart
                                disabled={_disabled}
                                ref={c=>this[fieldName+'_mp']=c}
                                values={field.val||[]}
                                onChange={(val, restart=true)=>{
                                    field.val = val
                                    field.wasChanged = true
                                    this[fieldName+'_mp'] = null
                                    this.updateSelection(()=>{
                                        if (restart && this[fieldName+'_mp']) {
                                            this[fieldName+'_mp'].startEditing()
                                        }
                                    })
                                }}
                            />
                        : <input
                            // disabled={_disabled}
                            readOnly={_disabled}
                            key={fieldName+'_input'}
                            type="text"
                            placeholder={field.val==='(...)'?'(...)':''}
                            value={field.val==='(...)'?(field.val=''):field.val}
                            className="details-input"
                            spellCheck="false"
                            onChange={(e)=>{
                                field.val = e.target.value;
                                field.wasChanged = true;
                                this.updateSelection()
                            }}
                        />
                // all of content
                return (
                    // title
                    <p
                        key={fieldName+'_p'}
                        className={
                            (fieldName==='year'||fieldName==='issue'||fieldName==='volume')
                                ?'onethird'+((fieldName==='year')
                                                ?' last'
                                                :'')
                                :''}
                    >
                        <strong>{field.label}</strong>
                        {contentSettings}
                        <br/>
                        {contentField}
                    </p>
                )
                break
        }

        console.log("ERROR", fieldName)
    }

    renderOneFieldCompare = (fieldName, item) => {
        var field = this.state.currentData[fieldName]
        var content = <br/>

        // if (fieldName==='url')
        //     console.log(item)
        if (field.val!==undefined) {
            switch (field.type) {
                case 'url':
                case 'files':
                case 'array':
                    if (item && item._compareType=='yellow' && item._diff[fieldName]) {
                        return (
                            <p key={fieldName}>
                                <strong>{field.label} </strong>
                                <br/>
                                {
                                    item._diff[fieldName].base.map(item=><span key={item} className="diff-red">{item}</span>)
                                }
                                {
                                    item._diff[fieldName].both.map(item=><span key={item} className="diff-none">{item}</span>)
                                }
                                {
                                    item._diff[fieldName].clone.map(item=><span key={item} className="diff-green">{item}</span>)
                                }
                            </p>
                        )
                    } else {
                        content = field.val.join(', ')
                    }
                    break

                //case 'color':
                case 'ref':
                case 'idsgroup':
                //case 'linkweight':
                //case 'linkwidth':
                //case 'linkshape':
                //case 'linksymbol':
                case 'likes':
                case 'layout':
                case '_render':
                    return null
                default:
                    content = (item && item._compareType==='yellow' && item._diff[fieldName])
                        ?   <span>
                                <span className="diff-red">{item._diff[fieldName].base}</span>
                                <span className="diff-green">{item._diff[fieldName].clone}</span>
                            </span>
                        : field.val
                    break
            }
        } else {
            return null
        }

        return (
            <p key={fieldName}>
                <strong>{field.label} </strong>
                <br/>
                {content}
            </p>
        )
    }

    renderCompare() {
        var selection = this.props.getSelection()

        // nothing is selected -> show nodebook information
        if (selection.nodes.length === 0 && selection.links.length === 0) {
            // var _adds = []
            // var _mods = []
            // var _dels = []
            // this.state.queuedDiffIds.forEach(
            //     item => {
            //         if (item._compareType==='green') {
            //             _adds.push(item)
            //         } else if (item._compareType==='yellow') {
            //             _mods.push(item)
            //         } else if (item._compareType==='red') {
            //             _dels.push(item)
            //         }
            //     }
            // )
            // var _addsJSX = (_adds.length===0)
            //         ?   null
            //         :   <p><strong>Additions:</strong> <br/>
            //                 {
            //                     _adds.map(item => <span key={item.id} className="nodebook-details-linkConns">{item.properties&&item.properties.title?item.properties.title:item.description}</span>)
            //                 }
            //             </p>

            // var _modsJSX = (_mods.length===0)
            //         ?   null
            //         :   <p>
            //                 <strong>Mods:</strong> <br/>
            //                 {
            //                     _mods.map(item => <span key={item.id} className="nodebook-details-linkConns">{item.properties&&item.properties.title?item.properties.title:item.description}</span>)
            //                 }
            //             </p>

            // var _delsJSX = (_dels.length===0)
            //         ?   null
            //         :   <p>
            //                 <strong>Removals:</strong> <br/>
            //                 {
            //                     _dels.map(item => <span key={item.id} className="nodebook-details-linkConns">{item.properties&&item.properties.title?item.properties.title:item.description}</span>)
            //                 }
            //             </p>
            // var queueOfChanges = (
            //     <div>
            //         {_addsJSX}
            //         {_modsJSX}
            //         {_delsJSX}
            //     </div>
            // )
            // var strs = []
            // if (_adds.length>0) { strs.push(`${_adds.length} addition(s)`) }
            // if (_mods.length>0) { strs.push(`${_mods.length} update(s)`) }
            // if (_dels.length>0) { strs.push(`${_dels.length} removal(s)`) }
            // var str = ''
            // if (strs.length===1) { str=strs[0] }
            // if (strs.length===2) { str=strs[0] + ' and ' + strs[1] }
            // if (strs.length===3) { str=strs[0] + ', ' + strs[1] + ' and ' + strs[2] }
            // var queueOfChanges = (
            //     <p>Total of {str}.</p>
            // )
            return (
                <div className="nodebook-details framed">
                    <div className="details-flex">
                        <div className="details">
                            {
                                // (this.state.queuedDiffIds.length>0)
                                //     ? queueOfChanges
                                //     : null
                            }
                            {
                                // (this.state.queuedDiffIds.length>0)
                                //     ? <span className="button">Save queued changes</span>
                                //     : null
                            }
                            {/*<span className="button" onClick={()=>{this.saveAllChanges()}}>Save all changes</span>*/}
                        </div>
                    </div>
                </div>
            )
        }

        // it's compare mode
        var item = null
        var itemCtrls = null
        if ((selection.nodes.length===1 && selection.links.length===0) ||
            (selection.nodes.length===0 && selection.links.length===1))
        {
            var _itemType = 'node'
            if (selection.nodes.length===1) { item = this.props.nodesData[this.props.nodesHashTable[selection.nodes[0]]] }
            if (selection.links.length===1) { item = this.props.linksData[this.props.linksHashTable[selection.links[0]]]; _itemType='link'}

            if (item._compareType!=='none') {
                itemCtrls = <span className="button" onClick={()=>{
                    this.saveChanges(item, _itemType)
                }}>Save changes</span>
            }
        }
        return (
            <div className="nodebook-details">
                <div className="details-flex">
                    <div className="details">
                        {itemCtrls}
                        {
                            this.mf.map(fieldName => this.renderOneFieldCompare(fieldName, item))
                        }
                    </div>
                </div>
                <div className="comments small">
                    <span>Selected {selection.nodes.length} nodes and {selection.links.length} links.</span>
                </div>
            </div>
        )
    }

    render() {
        if (this.props.isCompare) {
            return this.renderCompare()
        }

        var selection = this.props.getSelection()

        // const {currentData, queuedDiffIds, ...rest} = this.state
        // console.log(JSON.stringify(rest))

        // console.log("Details - render", selection.nodes.length, selection.links.length)

        let tabs = {
            info: null,
            versioning: null,
            discussion: null,
            settings: null,
            connections: null,
            appearance: null
        }

        // INFO
        if (this.state.infoTab) {
            if (selection.nodes.length === 0 && selection.links.length === 0) {
                tabs.info = <NodebookSettings {...this.props} />
            } else if ( (selection.nodes.length!==0 && selection.links.length===0) ||
                        (selection.nodes.length===0 && selection.links.length!==0 )) {
                tabs.info = (
                    <div className="details-flex">
                        <div className="details">
                        {
                            this.mf.map(fieldName => this.renderOneField(fieldName))
                        }
                        </div>
                    </div>
                )
            } else {
                tabs.info = (
                    <div className="details-flex">
                        <div className="details">
                            <p>Selected {selection.nodes.length} nodes and {selection.links.length} links.</p>
                        </div>
                    </div>
                )
            }
        }

        // VERSIONING
        if (this.state.versioningTab) {
            tabs.versioning = (
                <div className="details-flex">
                    <div className="details">
                        {
                            (this.props.nodebookInfo.permissions && this.props.authLevel[this.props.nodebookInfo.permissions]>1)
                                ? [<div key="btn_announce" style={{textAlign: 'center'}}>
                                    {
                                        (this.state.isPublished)
                                            ? <span className="msginfo">Nodebook published successfully.</span>
                                            : <span className="nicebtn publish" onClick={()=>{
                                                this.props.publishNodebook(()=>{
                                                    this.setState({
                                                        isPublished: true
                                                    }, ()=>{
                                                        setTimeout(()=>{
                                                            this.setState({
                                                                isPublished: false
                                                            })
                                                        }, 4000)
                                                    })
                                                })
                                            }}>
                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                                    <path d="M9.5 14c-1.93 0-3.5-1.57-3.5-3.5v-6c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5v6c0 1.93-1.57 3.5-3.5 3.5zM9.5 2c-1.378 0-2.5 1.122-2.5 2.5v6c0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5v-6c0-1.378-1.122-2.5-2.5-2.5z"></path>
                                                    <path d="M16 10.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5c0 3.033-2.467 5.5-5.5 5.5s-5.5-2.467-5.5-5.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5c0 3.416 2.649 6.225 6 6.481v2.019h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h4c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-2.019c3.351-0.256 6-3.065 6-6.481z"></path>
                                                </svg> Commit
                                            </span>
                                    }
                                </div>,
                                <hr key="horrule"/>]
                                : null
                        }
                        {
                            (this.props.branchesData && this.props.branchesData.parent)
                                ? (
                                    [
                                    <p key="parent_p"><strong>Origin</strong></p>,
                                    <div key="parent" className="branches parent">
                                        {this.props.nodebookInfo.canEdit === true ? <a className="option" onClick={()=>{this.props.requestMerge(this.props.branchesData.parent.id)}}>Propose changes</a> : null}
                                        &middot;
                                        <a href={`https://nodebook.io/nodebook/${this.props.match.params.id}/compare/${this.props.branchesData.parent.id}`} target="_blank" className="option">Compare</a>
                                        <div className="title"><Link to={`/nodebook/${this.props.branchesData.parent.id}`}>{this.props.branchesData.parent.title}</Link></div>
                                        <small><Link to={`/user/${this.props.branchesData.parent.author}`}>{this.props.branchesData.parent.author}</Link> &middot; {Utils.parseTimeDiff(new Date(this.props.branchesData.parent.date_created))}</small>
                                    </div>,
                                    <br key="brk"/>
                                    ]
                                ) : null
                        }
                        {
                            (this.state.isCloned)
                                ? <span className="msginfo">Nodebook cloned successfully.</span>
                                : <span className="nicebtn" onClick={()=>{
                                    this.props.cloneNodebook(()=>{
                                        this.setState({
                                            isCloned: true
                                        }, ()=>{
                                            setTimeout(()=>{
                                                this.setState({
                                                    isCloned: false
                                                })
                                            }, 4000)
                                        })
                                    })
                                }}>
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                        <path d="M15.5 19c-0.082 0-0.164-0.020-0.239-0.061l-3-1.636c-0.242-0.132-0.332-0.436-0.2-0.678s0.436-0.332 0.678-0.2l2.098 1.145-0.165-0.987c-0.045-0.272 0.139-0.53 0.411-0.575s0.53 0.139 0.575 0.411l0.333 2c0.031 0.189-0.048 0.379-0.203 0.49-0.086 0.061-0.188 0.093-0.29 0.093z"></path>
                                        <path d="M14.833 15c-0.24 0-0.452-0.173-0.493-0.418l-0.333-2c-0.027-0.159 0.025-0.322 0.14-0.436l1-1c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-0.818 0.818 0.291 1.746c0.045 0.272-0.139 0.53-0.411 0.575-0.028 0.005-0.055 0.007-0.083 0.007z"></path>
                                        <path d="M17.5 10c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l0.313-0.313-2.042-0.34c-0.272-0.045-0.456-0.303-0.411-0.575s0.303-0.456 0.575-0.411l3 0.5c0.185 0.031 0.337 0.162 0.394 0.341s0.010 0.374-0.123 0.506l-1 1c-0.098 0.098-0.226 0.147-0.354 0.147z"></path>
                                        <path d="M13.501 8.167c-0.027 0-0.055-0.002-0.083-0.007l-1-0.167c-0.158-0.026-0.293-0.127-0.365-0.27l-1-2c-0.123-0.247-0.023-0.547 0.224-0.671s0.547-0.023 0.671 0.224l0.886 1.772 0.749 0.125c0.272 0.045 0.456 0.303 0.411 0.575-0.041 0.244-0.253 0.418-0.493 0.418z"></path>
                                        <path d="M4.5 19c-0.102 0-0.204-0.031-0.29-0.093-0.156-0.111-0.235-0.301-0.203-0.49l0.958-5.746-3.818-3.818c-0.132-0.132-0.18-0.328-0.123-0.506s0.209-0.31 0.394-0.341l5.749-0.958 2.386-4.772c0.085-0.169 0.258-0.276 0.447-0.276 0 0 0 0 0 0 0.189 0 0.363 0.107 0.447 0.276l0.5 1c0.123 0.247 0.023 0.547-0.224 0.671s-0.547 0.023-0.671-0.224l-0.053-0.106-2.053 4.106c-0.072 0.143-0.207 0.243-0.365 0.27l-5.042 0.84 3.313 3.313c0.114 0.114 0.166 0.276 0.14 0.436l-0.831 4.987 4.599-2.508c0.149-0.081 0.33-0.081 0.479 0l0.5 0.273c0.242 0.132 0.332 0.436 0.199 0.678s-0.436 0.332-0.678 0.199l-0.261-0.142-5.261 2.869c-0.075 0.041-0.157 0.061-0.239 0.061z"></path>
                                    </svg> Fork
                                </span>
                        }

                        <br/>
                        {
                            (this.props.branchesData && this.props.branchesData.clones.length>0)
                                ? <p><strong>Forks</strong></p>
                                : null
                        }
                        {
                            (this.props.branchesData)
                                ? this.props.branchesData.clones.map(clone => (
                                    <div key={clone.id} className="branches">
                                        <a target="_blank" className="option" href={`https://nodebook.io/nodebook/${this.props.match.params.id}/compare/${clone.id}`}>Compare</a>
                                        <div className="title"><Link to={`/nodebook/${clone.id}`}>{clone.title}</Link></div>
                                        <small><Link to={`/user/${clone.author}`}>{clone.author}</Link> &middot; {Utils.parseTimeDiff(new Date(clone.date_created))}</small>
                                    </div>
                                )) : null

                        }
                    </div>
                </div>
            )
        }

        // DISCUSSION
        if (this.state.discussionTab) {
            if (selection.nodes.length === 0 && selection.links.length === 0) {
                tabs.discussion = (
                    <div className="details-flex">
                        <NodebookComments
                            auth={this.props.auth}
                            nodebook={this.props.nodebookInfo}
                            item={this.props.nodebookInfo}
                            type={'nodebook'}
                        />
                    </div>
                )
            } else if (selection.nodes.length === 1 && selection.links.length === 0) {
                tabs.discussion = (
                    <div className="details-flex">
                        <NodebookComments
                            auth={this.props.auth}
                            nodebook={this.props.nodebookInfo}
                            item={this.props.nodesData[this.props.nodesHashTable[selection.nodes[0]]]}
                            id={selection.nodes[0]}
                            type={'node'}
                        />
                    </div>
                )
            } else if (selection.nodes.length === 0 && selection.links.length === 1) {
                tabs.discussion = (
                    <div className="details-flex">
                        <NodebookComments
                            auth={this.props.auth}
                            nodebook={this.props.nodebookInfo}
                            item={this.props.linksData[this.props.linksHashTable[selection.links[0]]]}
                            id={selection.links[0]}
                            type={'link'}
                        />
                    </div>
                )
            }
        }

        // SETTINGS
        if (this.state.settingsTab) {
            tabs.settings = (
                <div className="details-flex">
                    <div className="details">
                        <p><strong>Permissions</strong></p>
                        <PermissionsManager
                            currentUser={this.props.auth.user}
                            groupId={this.props.nodebookInfo.group_id}
                            authLevel={this.props.authLevel}
                            permissions={this.props.nodebookInfo.permissions}
                            getShareTokenFromParams={this.props.getShareTokenFromParams}
                            match={this.props.match}
                        />
                        {
                            (this.props.nodebookInfo.permissions==='admin')
                                ? [
                                    <br key="br"/>,
                                    <hr key="hr"/>,
                                    <p key="p"><strong>Delete nodebook</strong></p>,
                                    (this.state.isDeleteConfirm)
                                        ? <span key="confirm" className="msginfo">Are you sure you want to delete this nodebook? <br/><a onClick={()=>{this.props.deleteNodebook(()=>{this.props.history.push(`/user/${this.props.nodebookInfo.username}`)})}}>Yes</a> &middot; <a onClick={()=>{this.setState({isDeleteConfirm: false})}}>No</a></span>
                                        : <span key="btn" className="nicebtn delete" onClick={()=>{this.setState({isDeleteConfirm: true})}}>
                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                                <path d="M15.5 2h-3.5v-0.5c0-0.827-0.673-1.5-1.5-1.5h-2c-0.827 0-1.5 0.673-1.5 1.5v0.5h-3.5c-0.827 0-1.5 0.673-1.5 1.5v1c0 0.652 0.418 1.208 1 1.414v12.586c0 0.827 0.673 1.5 1.5 1.5h10c0.827 0 1.5-0.673 1.5-1.5v-12.586c0.582-0.206 1-0.762 1-1.414v-1c0-0.827-0.673-1.5-1.5-1.5zM8 1.5c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v0.5h-3v-0.5zM14.5 19h-10c-0.276 0-0.5-0.224-0.5-0.5v-12.5h11v12.5c0 0.276-0.224 0.5-0.5 0.5zM16 4.5c0 0.276-0.224 0.5-0.5 0.5h-12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5h12c0.276 0 0.5 0.224 0.5 0.5v1z"></path>
                                                <path d="M12.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z"></path>
                                                <path d="M9.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z"></path>
                                                <path d="M6.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z"></path>
                                            </svg> Delete
                                        </span>
                                    ]
                                : null
                        }

                    </div>
                </div>
            )
        }

        // CONNECTIONS
        if (this.state.connectionsTab) {
            let node = this.props.nodesData[this.props.nodesHashTable[selection.nodes[0]]]
            if (!node) {
                return null
            }
            let cons = []
            node.linksList.map(
                linkId => {
                    var link = this.props.linksData[this.props.linksHashTable[linkId]]
                    var otherNodeId = link.from_id===node.id?link.to_id:link.from_id
                    var otherNode = this.props.nodesData[this.props.nodesHashTable[otherNodeId]]
                    var key = link.from_id+'_'+link.to_id
                    cons.push(otherNode)
                }
            )
            cons.sort((a,b)=>{
                if (a.properties.title > b.properties.title) return 1
                if (a.properties.title < b.properties.title) return -1
                return 0
            })
            tabs.connections = (
                <div className="details-flex">
                    <div className="details">
                        <p><strong>Connected nodes ({node.linksList.length})</strong><br/>
                        {
                            cons.map(
                                (con, id) => (
                                    <span key={node.id+'_'+con.id+'_'+id} className="nodebook-details-linkConns" onClick={()=>{
                                        this.props.selectNode(con)
                                        this.props.transformToSelection()
                                    }}>{con.properties.title===''?'(untitled node)':con.properties.title}</span>
                                )
                            )
                        }
                        </p>
                    </div>
                </div>
            )
        }

        // APPEARANCE
        if (this.state.appearanceTab) {
            if (selection.nodes.length !== 0 || selection.links.length !== 0) {
                tabs.appearance = (
                    <div className="details-flex">
                        <div className="details">
                        {
                            this.mf.map(fieldName => this.renderOneField(fieldName, true))
                        }
                        </div>
                    </div>
                )
            }
        }

        return (
            <div className="nodebook-details">
                {tabs[this.state.selectedTab]}
                <div className="tabss">
                {
                    (this.state.infoTab)
                        ? (
                            <span className={this.state.selectedTab==='info'?'selected':''} onClick={()=>{this.setState({selectedTab: 'info'})}}>
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                    <path d="M18.5 18h-17c-0.827 0-1.5-0.673-1.5-1.5v-13c0-0.827 0.673-1.5 1.5-1.5h17c0.827 0 1.5 0.673 1.5 1.5v13c0 0.827-0.673 1.5-1.5 1.5zM1.5 3c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h17c0.276 0 0.5-0.224 0.5-0.5v-13c0-0.276-0.224-0.5-0.5-0.5h-17z"></path>
                                    <path d="M9.5 6h-6c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h6c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path d="M9.5 9h-6c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h6c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path d="M9.5 11h-6c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h6c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path d="M9.5 13h-6c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h6c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path d="M8.5 15h-5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"></path>
                                    <path d="M17.943 6.544l-0.813-0.591-0.311-0.956h-1.005l-0.813-0.591-0.813 0.591h-1.005l-0.311 0.956-0.813 0.591 0.311 0.956-0.311 0.956 0.813 0.591 0.132 0.406c-0.002 0.016-0.002 0.031-0.002 0.047v5c0 0.202 0.122 0.385 0.309 0.462s0.402 0.035 0.545-0.108l1.146-1.146 1.146 1.146c0.096 0.096 0.223 0.147 0.354 0.146 0.064 0 0.129-0.012 0.191-0.038 0.187-0.077 0.309-0.26 0.309-0.462v-5c0-0.016-0.001-0.032-0.002-0.047l0.132-0.406 0.813-0.591-0.311-0.956 0.311-0.956zM13.233 6.926l0.488-0.355 0.187-0.574h0.604l0.488-0.355 0.488 0.355h0.604l0.187 0.574 0.488 0.355-0.187 0.574 0.187 0.574-0.488 0.355-0.187 0.574h-0.604l-0.488 0.355-0.488-0.355h-0.604l-0.187-0.574-0.488-0.355 0.187-0.574-0.187-0.574zM15.354 12.646c-0.195-0.195-0.512-0.195-0.707 0l-0.646 0.646v-3.29h0.187l0.813 0.591 0.813-0.591h0.187v3.29l-0.646-0.646z"></path>
                                </svg> Info
                            </span>
                        ) : null
                }
                {
                    (this.state.versioningTab)
                        ? (
                            <span className={this.state.selectedTab==='versioning'?'selected':''} onClick={()=>{this.setState({selectedTab: 'versioning'})}}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                    <path d="M2.782 3.782c-1.794 1.794-2.782 4.18-2.782 6.718s0.988 4.923 2.782 6.718 4.18 2.782 6.718 2.782 4.923-0.988 6.718-2.782 2.782-4.18 2.782-6.717-0.988-4.923-2.782-6.718-4.18-2.782-6.718-2.782-4.923 0.988-6.718 2.782zM18 10.5c0 4.687-3.813 8.5-8.5 8.5s-8.5-3.813-8.5-8.5c0-4.687 3.813-8.5 8.5-8.5s8.5 3.813 8.5 8.5z"></path>
                                    <path d="M9.147 4.647l-4 4c-0.195 0.195-0.195 0.512 0 0.707s0.512 0.195 0.707 0l3.146-3.147v10.293c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10.293l3.147 3.146c0.195 0.195 0.512 0.195 0.707 0 0.098-0.098 0.146-0.226 0.146-0.353s-0.049-0.256-0.147-0.353l-4-4c-0.195-0.195-0.512-0.195-0.707 0z"></path>
                                </svg> Forks
                            </span>
                        ) : null
                }
                {
                    (this.state.connectionsTab)
                        ? (
                            <span className={this.state.selectedTab==='connections'?'selected':''} onClick={()=>{this.setState({selectedTab: 'connections'})}}>
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                    <path d="M10.682 12.998c-0.943 0-1.886-0.359-2.604-1.077-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0c1.046 1.046 2.747 1.046 3.793 0l3.636-3.636c1.046-1.046 1.046-2.747 0-3.793s-2.747-1.046-3.793 0l-3.068 3.068c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707l3.068-3.068c1.436-1.436 3.772-1.436 5.207 0s1.436 3.772 0 5.207l-3.636 3.636c-0.718 0.718-1.661 1.077-2.604 1.077z"></path>
                                    <path d="M4.682 18.998c-0.943 0-1.886-0.359-2.604-1.077-1.436-1.436-1.436-3.772 0-5.207l3.636-3.636c1.436-1.436 3.772-1.436 5.207 0 0.195 0.195 0.195 0.512 0 0.707s-0.512 0.195-0.707 0c-1.046-1.046-2.747-1.046-3.793 0l-3.636 3.636c-1.046 1.046-1.046 2.747 0 3.793s2.747 1.046 3.793 0l3.068-3.068c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-3.068 3.068c-0.718 0.718-1.661 1.077-2.604 1.077z"></path>
                                </svg> Links
                            </span>
                        ) : null
                }
                {
                    (this.state.discussionTab)
                        ? (
                            <span className={this.state.selectedTab==='discussion'?'selected':''} onClick={()=>{this.setState({selectedTab: 'discussion'})}}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                   <path d="M0.5 19c-0.225 0-0.422-0.15-0.482-0.367s0.032-0.447 0.225-0.562c1.691-1.014 2.392-2.489 2.641-3.179-1.838-1.407-2.884-3.354-2.884-5.392 0-1.029 0.258-2.026 0.768-2.964 0.486-0.894 1.18-1.695 2.061-2.381 1.787-1.39 4.156-2.156 6.671-2.156s4.884 0.766 6.671 2.156c0.881 0.685 1.575 1.486 2.061 2.381 0.51 0.937 0.768 1.934 0.768 2.964s-0.258 2.026-0.768 2.964c-0.486 0.894-1.18 1.695-2.061 2.381-1.787 1.39-4.156 2.156-6.671 2.156-1.033 0-2.047-0.129-3.016-0.385-0.429 0.286-1.231 0.793-2.189 1.27-1.488 0.74-2.764 1.115-3.794 1.115zM9.5 3c-4.687 0-8.5 2.916-8.5 6.5 0 1.815 1.005 3.562 2.756 4.792 0.172 0.121 0.25 0.336 0.196 0.539-0.117 0.436-0.515 1.633-1.58 2.788 1.302-0.456 2.704-1.247 3.739-1.959 0.123-0.085 0.277-0.11 0.421-0.069 0.948 0.271 1.947 0.409 2.968 0.409 4.687 0 8.5-2.916 8.5-6.5s-3.813-6.5-8.5-6.5z"/>
                                </svg> Comments
                            </span>
                        ) : null
                }
                {
                    (this.state.settingsTab)
                        ? (
                            <span className={this.state.selectedTab==='settings'?'selected':''} onClick={()=>{this.setState({selectedTab: 'settings'})}}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                    <path d="M7.631 19.702c-0.041 0-0.083-0.005-0.125-0.016-0.898-0.231-1.761-0.587-2.564-1.059-0.233-0.137-0.315-0.434-0.186-0.671 0.159-0.292 0.243-0.622 0.243-0.957 0-1.103-0.897-2-2-2-0.334 0-0.665 0.084-0.957 0.243-0.237 0.129-0.534 0.047-0.671-0.186-0.472-0.804-0.828-1.666-1.059-2.564-0.065-0.254 0.077-0.515 0.325-0.598 0.814-0.274 1.362-1.036 1.362-1.895s-0.547-1.621-1.362-1.895c-0.248-0.084-0.39-0.344-0.325-0.598 0.231-0.898 0.587-1.761 1.059-2.564 0.137-0.233 0.434-0.315 0.671-0.186 0.291 0.159 0.622 0.243 0.957 0.243 1.103 0 2-0.897 2-2 0-0.334-0.084-0.665-0.243-0.957-0.129-0.237-0.047-0.534 0.186-0.671 0.804-0.472 1.666-0.828 2.564-1.059 0.254-0.065 0.515 0.077 0.598 0.325 0.274 0.814 1.036 1.362 1.895 1.362s1.621-0.547 1.895-1.362c0.084-0.248 0.345-0.39 0.598-0.325 0.898 0.231 1.761 0.587 2.564 1.059 0.233 0.137 0.315 0.434 0.186 0.671-0.159 0.292-0.243 0.622-0.243 0.957 0 1.103 0.897 2 2 2 0.334 0 0.665-0.084 0.957-0.243 0.237-0.129 0.534-0.047 0.671 0.186 0.472 0.804 0.828 1.666 1.059 2.564 0.065 0.254-0.077 0.515-0.325 0.598-0.814 0.274-1.362 1.036-1.362 1.895s0.547 1.621 1.362 1.895c0.248 0.084 0.39 0.344 0.325 0.598-0.231 0.898-0.587 1.761-1.059 2.564-0.137 0.233-0.434 0.315-0.671 0.186-0.292-0.159-0.622-0.243-0.957-0.243-1.103 0-2 0.897-2 2 0 0.334 0.084 0.665 0.243 0.957 0.129 0.237 0.047 0.534-0.186 0.671-0.804 0.472-1.666 0.828-2.564 1.059-0.254 0.065-0.515-0.077-0.598-0.325-0.274-0.814-1.036-1.362-1.895-1.362s-1.621 0.547-1.895 1.362c-0.070 0.207-0.264 0.341-0.474 0.341zM10 17c1.127 0 2.142 0.628 2.655 1.602 0.52-0.161 1.026-0.369 1.51-0.622-0.108-0.314-0.164-0.646-0.164-0.98 0-1.654 1.346-3 3-3 0.334 0 0.666 0.056 0.98 0.164 0.253-0.484 0.462-0.989 0.622-1.51-0.974-0.512-1.602-1.527-1.602-2.655s0.628-2.142 1.602-2.655c-0.161-0.52-0.369-1.026-0.622-1.51-0.314 0.108-0.646 0.164-0.98 0.164-1.654 0-3-1.346-3-3 0-0.334 0.056-0.666 0.164-0.98-0.484-0.253-0.989-0.462-1.51-0.622-0.512 0.974-1.527 1.602-2.655 1.602s-2.142-0.628-2.655-1.602c-0.52 0.16-1.026 0.369-1.51 0.622 0.108 0.314 0.164 0.646 0.164 0.98 0 1.654-1.346 3-3 3-0.334 0-0.666-0.056-0.98-0.164-0.253 0.484-0.462 0.989-0.622 1.51 0.974 0.512 1.602 1.527 1.602 2.655s-0.628 2.142-1.602 2.655c0.16 0.52 0.369 1.026 0.622 1.51 0.314-0.108 0.646-0.164 0.98-0.164 1.654 0 3 1.346 3 3 0 0.334-0.056 0.666-0.164 0.98 0.484 0.253 0.989 0.462 1.51 0.622 0.512-0.974 1.527-1.602 2.655-1.602z"></path>
                                    <path d="M10 13c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zM10 8c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2z"></path>
                                </svg> Settings
                            </span>
                        ) : null
                }
                {
                    (this.state.appearanceTab)
                        ? (
                            <span className={this.state.selectedTab==='appearance'?'selected':''} onClick={()=>{this.setState({selectedTab: 'appearance'})}}>
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
                                    <path d="M10 20c-1.614 0-3.118-0.655-4.236-1.845-1.133-1.206-1.757-2.859-1.757-4.655 0-2.943 1.308-5.049 2.693-7.278 1.070-1.723 2.177-3.504 2.817-5.853 0.059-0.218 0.257-0.368 0.482-0.368s0.423 0.151 0.482 0.368c0.641 2.35 1.749 4.132 2.821 5.855 1.387 2.229 2.697 4.335 2.697 7.277 0 1.799-0.62 3.452-1.746 4.654-1.115 1.19-2.626 1.846-4.254 1.846zM10 2.113c-0.674 1.776-1.574 3.225-2.45 4.636-1.364 2.196-2.543 4.093-2.543 6.751 0 3.136 2.147 5.5 4.993 5.5 2.85 0 5-2.364 5-5.5 0-2.657-1.18-4.553-2.546-6.749-0.878-1.411-1.78-2.861-2.454-4.638z"></path>
                                </svg> Appearance
                            </span>
                        ) : null
                }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/NodebookDetails.js